export default __webpack_public_path__ + "static/media/selected_icon.5a7a675e.svg";